import React from "react";

import { UserListingProvider } from "../context/UserListingProvider";
import { UsersListing } from "./UsersListing";

export const UsersDashboard: React.FC = () => {
    return (
        <UserListingProvider>
            <UsersListing />
        </UserListingProvider>
    );
};
